import { type TranslationTree } from '@/i18n/types';

export const messages = {
  slot: {
    marketplace_top: 'Marketplace',
    body_metrics: 'Corpo',
    profile: 'Perfil',
    planning: 'Planejamento',
    plus_club: 'Clube Bodyprint+',
  },
  slotsJoin: '{{list}} e {{last}}',
  period: {
    range: '{{from}} a {{to}}',
    since: 'Desde {{from}}',
  },
} satisfies TranslationTree;
